import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../theme';
import OrderPreview from './OrderPreview/OrderPreview';
import OrderStatus from './OrderStatus/OrderStatus';
import OrderBooking from './OrderBooking/OrderBooking';
import OrderPassengers from './OrderPassengers/OrderPassengers';
import OrderCardControls from './OrderCardControls/OrderCardControls';
import { MOBILE_MIN_WIDTH } from '../../utils';
import { OrderStatus as OrderStatusType } from '@websky/graphql';
import OrderTickets from './OrderTickets/OrderTickets';
import { BaseButton } from '../../BaseComponents';
import PaymentStatus from './PaymentStatus/PaymentStatus';
import MediaQuery from 'react-responsive';
import { useTranslation } from 'react-i18next';
import OrderChange from './OrderChange/OrderChange';
import { useRenderers } from '../../renderProps';
import { useConfig } from '../../context';
import DeleteOrderModal from './DeleteOrderModal/DeleteOrderModal';
import { CheckinCard } from '@shared/CheckinCard';
export const OrderCardContext = React.createContext(null);
const OrderCard = props => {
    var _a, _b;
    const { type, accountOrderAdditionalItem, accountOrderAdditionalButtons } = props;
    const { OrderCard: css } = useTheme('OrderCard');
    const { t } = useTranslation('OrderCard');
    const { renderOrderCardStatus: RenderOrderCardStatusOverride = OrderStatus, renderOrderCardBooking: RenderOrderCardBookingOverride = OrderBooking } = useRenderers();
    const { global: { reserveEngines, companyInfo: { iataCode } } } = useConfig();
    const isArmeniaOrGeorgian = iataCode === 'RM' || iataCode === 'A9';
    const onClickHandler = () => {
        if (typeof props.onClick === 'function') {
            props.onClick(props.order.id);
        }
    };
    const exchangeAvailable = (_a = props.order.exareInfo) === null || _a === void 0 ? void 0 : _a.exchangeAvailability;
    const refundAvailable = (_b = props.order.exareInfo) === null || _b === void 0 ? void 0 : _b.refundAvailability;
    const onOrderChangeClick = (buttonType) => {
        buttonType === 'exchange' ? props.goToExchange() : props.goToRefund();
    };
    return (React.createElement(OrderCardContext.Provider, { value: props },
        React.createElement(CheckinCard, { className: cn(css.container, css.root__checkinCard, {
                [css.type_review]: type === 'review',
                [css.type_account]: type === 'account'
            }) },
            React.createElement(OrderPreview, { className: css.preview, onClick: props.onClick && onClickHandler }),
            React.createElement("div", { className: cn(css.root, { [css.orderConfirmed]: props.order.status === OrderStatusType.Confirmed }) },
                type === 'review' && (React.createElement(React.Fragment, null,
                    React.createElement(RenderOrderCardStatusOverride, { className: cn(css.item, css.status) }),
                    React.createElement(PaymentStatus, null),
                    React.createElement(RenderOrderCardBookingOverride, { className: cn(css.item, css.booking), hidePrice: props.hidePrice, onDownloadTicket: props.onDownloadClick }),
                    (!(reserveEngines === null || reserveEngines === void 0 ? void 0 : reserveEngines.redirectToWebsky1) || !isArmeniaOrGeorgian) && React.createElement(OrderCardControls, null),
                    React.createElement(OrderPassengers, { className: cn(css.item, css.passengers), goToChangePassenger: props.goToChangePassenger }),
                    props.order.status === OrderStatusType.Confirmed && type === 'review' && (React.createElement(OrderTickets, { className: cn(css.item, css.tickets) })),
                    (exchangeAvailable || refundAvailable) && (React.createElement(OrderChange, { onClick: onOrderChangeClick, exchangeAvailable: exchangeAvailable, refundAvailable: refundAvailable })))),
                type === 'account' && (React.createElement(React.Fragment, null,
                    props.order.status === OrderStatusType.Confirmed && (React.createElement(RenderOrderCardStatusOverride, { className: cn(css.item, css.status) })),
                    React.createElement(OrderBooking, { className: cn(css.item, css.booking), hidePrice: props.hidePrice }),
                    React.createElement(OrderPassengers, { className: cn(css.item, css.passengers) }),
                    React.createElement(PaymentStatus, null), accountOrderAdditionalItem === null || accountOrderAdditionalItem === void 0 ? void 0 :
                    accountOrderAdditionalItem(),
                    React.createElement("div", { className: css.buttons },
                        React.createElement(DeleteOrderModal, { orderId: props.order.id, orderLocator: props.order.locator, onDeleted: props.onDeleted }),
                        React.createElement(MediaQuery, { minWidth: MOBILE_MIN_WIDTH }, accountOrderAdditionalButtons === null || accountOrderAdditionalButtons === void 0 ? void 0 :
                            accountOrderAdditionalButtons(),
                            React.createElement(BaseButton, { variant: "smallPrimary", className: css.openOrder, onClick: onClickHandler }, t('Open'))))))))));
};
export default OrderCard;
